import {ConnectionFactory, DefaultController} from "../../../backends/YiiRoutes";
import NotificationManager from '../../notifications/NotificationManager';
import EventBlockObject from "./BlockObjects/EventBlockObject";
import FacebookBlockObject from "./BlockObjects/FacebookBlockObject";
import GenericBlockObject from "./BlockObjects/GenericBlockObject";
import GroupBlockObject from "./BlockObjects/GroupBlockObject";
import HtmlBlockObject from "./BlockObjects/HTMLBlockObject";
import InstagramBlockObject from "./BlockObjects/InstagramBlockObject";
import MessageBlockObject from "./BlockObjects/MessageBlockObject";
import QuickLinkBlockObject from "./BlockObjects/QuickLinkBlockObject";
import NewsBlockObject from "./BlockObjects/NewsBlockObject";
import OrganizationBlockObject from "./BlockObjects/OrganizationBlockObject";
import PinterestBlockObject from "./BlockObjects/PinterestBlockObject";
import PollBlockObject from "./BlockObjects/PollBlockObject";
import PageBlockObject from "./BlockObjects/PageBlockObject";
import ReuseBlockObject from "./BlockObjects/ReuseBlockObject";
import SharedFilesBlockObject from "./BlockObjects/SharedFilesBlockObject";
import SocialBlockObject from "./BlockObjects/SocialBlockObject";
import StaffBlockObject from "./BlockObjects/StaffBlockObject";
import TwitterBlockObject from "./BlockObjects/TwitterBlockObject";
import VideoBlockObject from "./BlockObjects/VideoBlock/VideoBlockObject";
import WeatherBlockObject from "./BlockObjects/WeatherBlockObject";
import ajaxGetQueue from "../../../backends/AjaxQueue";
import {isJson} from "../../admin/spinup/utilities";
import WatsonApi, {buildSwaggerAuthorization} from "../../../backends/WatsonApi";
import {getIconSetFromUrl, getLegacyFileIcon} from "../CleverSiteTheme/FilesFoldersBlock/fileUtilities";
import {getCdnUrl} from "../../../utils/SchoolBlocksUtilities";
import PersonBlockObject from "./BlockObjects/PersonBlockObject";

export function blockObjectFactory(blockType, initialProps) {
    switch (blockType) {
        case "eventlist": return new EventBlockObject(blockType, initialProps);
        case "group":
        case "department":
        case "section":
        case "team":
            return new GroupBlockObject(blockType, initialProps);
        case "facebook": return new FacebookBlockObject(blockType, initialProps);
        case "html": return new HtmlBlockObject(blockType, initialProps);
        case "instagram": return new InstagramBlockObject(blockType, initialProps);
        case "message": return new MessageBlockObject(blockType, initialProps);
        case "news": return new NewsBlockObject(blockType, initialProps);
        case "school":
        case "district":
        case "organization":
            return new OrganizationBlockObject(blockType, initialProps);
        case "page": return new PageBlockObject(blockType, initialProps);
        case "person": return new PersonBlockObject(blockType, initialProps);
        case "pinterest": return new PinterestBlockObject(blockType, initialProps);
        case "poll": return new PollBlockObject(blockType, initialProps);
        case "quicklink": return new QuickLinkBlockObject(blockType, initialProps);
        case "reuse": return new ReuseBlockObject(blockType, initialProps);
        case "sharedfiles": return new SharedFilesBlockObject(blockType, initialProps);
        case "staff": return new StaffBlockObject(blockType, initialProps);
        case "twitter": return new TwitterBlockObject(blockType, initialProps);
        case "weather": return new WeatherBlockObject(blockType, initialProps);
        case "youtube":
        case "video": return new VideoBlockObject(blockType, initialProps);
        default:
            return new GenericBlockObject(blockType, initialProps);
    }
}

function reactifyCssProperty(property) {
    // check for properties like "margin-top" and replace with "marginTop"
    const shouldFormatRegex = /(-)(\S){1}/;
    if (shouldFormatRegex.test(property)) {
        const match = property.match(shouldFormatRegex);
        return property.replace(shouldFormatRegex, match[2].toUpperCase());
    }
    return property;
}

export function cssStringToObject(str) {
    if (typeof str !== "string") return str;
    return str
        .split("; ")
        .map(s => s.replace(/[;\s]*/g, "").split(":"))
        .reduce((acc, curr) => Object.assign(acc, {[reactifyCssProperty(curr[0])]: curr[1]}), {});
}

const defaultByCategory = {
    "root.6b4ae6c8b4664ab184d64b23c2951ee8": require("../../../assets/images/defaultByCategory/root.6b4ae6c8b4664ab184d64b23c2951ee8-ccahPlaceHolder.jpg"),
    "root.240b6abc2c7f4b80a415c9e5e8e81251": require("../../../assets/images/defaultByCategory/root.240b6abc2c7f4b80a415c9e5e8e81251-ccahPlaceHolder.jpg"),
    "root.fd9883dfb4d046d0bbf54e8034392c56": require("../../../assets/images/defaultByCategory/root.fd9883dfb4d046d0bbf54e8034392c56-ccahPlaceHolder.jpg"),
};

function getPathAsList(path) {
    const pathComponents = path.split(".");
    return pathComponents.reduce((acc, curr) => {
        if (acc.length === 0) {
            acc.push(curr);
        } else {
            acc.push(`${acc[acc.length - 1]}.${curr}`)
        }
        return acc;
    }, [])
}

export function getDefaultOrganizationUrl(organizationModel) {
    let pictureUrl = "";
    if (organizationModel.all_categories) {
        const primaryCategory = organizationModel.all_categories[0];
        const paths = getPathAsList(primaryCategory.path).reverse();
        for (let i = 0; i < paths.length; i++) {
            if (defaultByCategory[paths[i]]) {
                pictureUrl = defaultByCategory[paths[i]];
                break;
            }
        }
    }
    return pictureUrl;
}

export function getLogoUrl(organizationModel) {
    if (organizationModel.json_data?.settings?.logo) {
        return getCdnUrl(organizationModel.json_data.settings.logo);
    }
    return null;
}

export function getPictureUrl(organizationModel) {
    if (organizationModel.json_data?.settings?.picture) {
        return getCdnUrl(organizationModel.json_data.settings.picture);
    } else {
        switch (organizationModel.type) {
            case "district":
            case "school":
                return require("../../../assets/images/school_photo.png");
            default:
                return getDefaultOrganizationUrl(organizationModel);
        }
    }
}

export function getAvatarUrl(personModel) {
    if (personModel.avatarUrl) {
        return personModel.avatarUrl;
    }
    return require("../../../assets/images/person-placeholder.jpg");
}

export function getBlockIconByType(blockType) {
    switch (blockType) {
        case "social":
        case "youtube":
        case "facebook":
        case "twitter":
        case "pinterest":
        case "instagram":
            return require("../../../assets/images/menu_icon_social.png");
        case "sharedfiles":
            return require("../../../assets/images/menu_icon_files.png");
        case "schooltube":
            return require("../../../assets/images/schooltube_icon.png");
        case "group":
        case "section":
        case "department":
            return require("../../../assets/images/menu_icon_section.png");
        default:
            return ""
    }
}

export function getLogoHtml(block) {
    let iconHtml = "";

    let branding = block.branding;
    let title = block.title;

    if (branding.logo?.fontawesome) {
        iconHtml = <span className={branding.logo.fontawesome} role="img" aria-label={branding.ariaLabel}/>
    } else if (block.model.type === "sharedfiles") {
        const fakeBlockObject = {
            type: block.component.settings.fileType,
            viewerType: getIconSetFromUrl(block.component.settings.url),
        }
        const imageUrl = getLegacyFileIcon(fakeBlockObject);
        iconHtml = <img className={"sb-block-logo"} style={{marginTop: "1em", height: "2em", width: "auto"}} src={imageUrl} alt={title}/>
    } else {
        const iconCss = branding.logo?.iconCss ? cssStringToObject(branding.logo.iconCss) : {height: "70%"};
        iconHtml = <img className={"sb-block-logo"} style={iconCss} src={getBlockIconByType(block.model.type)} alt={title}/>
    }

    return iconHtml;
}

var _resizeTimeout;

export function itemResize(pckryInstance, event) {
    // debounce
    if (_resizeTimeout) {
        clearTimeout(_resizeTimeout);
    }

    _resizeTimeout = setTimeout(function () {
        pckryInstance.fit(event.target);
    }, 10);
    event.stopPropagation();
}

export function itemStopResize(locale, gridStore, pckryInstance, event, ui) {
    const Packery = require("packery");
    require("velocity-animate");

    var targetBlock = $(ui.element[0]),
        targetItem = pckryInstance.getItem(targetBlock[0]),
        targetItemRect,
        overlaps = false,
        newSize;

    newSize = sb_getGridCoord(pckryInstance, targetBlock);

    targetItemRect = new Packery.Rect({
        x: targetItem.rect.x,
        y: targetItem.rect.y,
        width: newSize.width,
        height: newSize.height,
    });

    for (var i = 0; i < pckryInstance.stamps.length; i++) {
        // Note: the stamped item MUST be an actual "item" so we can get the rect.x,rect.y coordinates.
        // Otherwise the stamped item is just a DOM element.
        var stamped = pckryInstance.getItem(pckryInstance.stamps[i]);

        // Unfortunately, the position/size are not always set.  Not sure why, but this way we get the current
        // position and size of the stamp prior to checking for overlaps.
        stamped.getPosition();
        var stampRect = new Packery.Rect({
            x: stamped.position.x,
            y: stamped.position.y,
        });
        pckryInstance._setRectSize(stamped.element, stampRect);

        // Modified Rect.overlaps() to handle single pixel overlap so that the below test works reliably.
        if (stamped && targetItemRect.overlaps(stampRect)) {
            // The item overlaps, so cancel the resize
            overlaps = true;
            newSize.width = ui.originalSize.width;
            newSize.height = ui.originalSize.height;
            break;
        }
    }

    targetBlock.velocity({
        'width': newSize.width,
        'height': newSize.height,
    }, 300, function () {

        if (overlaps === true) {
            // Make sure we snap the grid back after resizing, in case blocks were moved out of the way.
            pckryInstance.layout();
            targetBlock.trigger('schoolblocks.resize');
            targetBlock.trigger('blockload.sbeditor');
        } else {
            const blockId = targetBlock.data('id');
            gridStore.resizeBlock(blockId, newSize.gridCoordX, newSize.gridCoordY);

            // TODO: are these triggers necessary?
            targetBlock.trigger('schoolblocks.resize');
            targetBlock.trigger('blockload.sbeditor');

            sb_updateGrid(locale, gridStore, blockId);
        }
    });
}

export function toggleBlockLock(gridStore, packeryInstance, blockEl) {
    var mainGrid = $('#main-grid'),
        $block = $(blockEl),
        stampClass = "sb-position-locked",
        newSize = sb_getGridCoord(packeryInstance, $block);

    const blockId = $block.data('id');

    setBlockSizeAndPosition(packeryInstance, $block, newSize);

    if ($block.hasClass(stampClass)) {
        // unlock the block
        unlockBlockPosition($block.data("id"), gridStore.id).done(function (res) {
            if (res.success === true) {
                gridStore.unlockBlock(blockId);
                $block.resizable({'handles': 'e, s, se'});

                NotificationManager.success('Block position has been unlocked.');
            } else {
                NotificationManager.error('Block position failed to unlock.  Please try again.');
            }
        });
    } else {
        // lock the block
        lockBlockPosition(newSize, $block.data("id"), gridStore.id).done(function (res) {
            if (res.success === true) {
                gridStore.lockBlock(blockId, $block.data("pos-x"), $block.data("pos-y"));

                if ($block.resizable('instance')) {
                    $block.resizable('destroy');
                } else {
                    $block.removeClass('resizable ui-resizable');
                    $block.find('.ui-resizable-handle').remove();
                }

                NotificationManager.success('Block position has been locked.');
            } else {
                NotificationManager.error('Block position failed to lock. Please try again.');
            }
        });
    }
}

export function setBlockSizeAndPosition(pckryInstance, $block, newSize) {


    if (newSize === undefined || newSize === null) {
        newSize = sb_getGridCoord(pckryInstance, $block);
    }

    $block.data("size-x", newSize.gridCoordX);
    $block.data("size-y", newSize.gridCoordY);
    $block.data("pos-x", newSize.posX);
    $block.data("pos-y", newSize.posY);
}

export function sb_getGridCoord(pckryInstance, block) {

    const blockDimensions = getBlockDimensions(pckryInstance, block);
    const blockPosition = getBlockPosition(pckryInstance, block);
    const newCoords = {
        ...blockDimensions,
        ...blockPosition,
    }

    return newCoords;
}

export function getBlockPosition(pckryInstance, block) {
    const columnWidth = Math.round(pckryInstance.columnWidth),
          rowHeight = Math.round(pckryInstance.rowHeight),
          $block = $(block);

    let newCoords = {};
    // Must use some round/ceil/floor when doing any arithmetic here!!!!
    newCoords.posX = Math.round($block.position().left / columnWidth);
    newCoords.posY = Math.round($block.position().top / rowHeight);

    return newCoords;
}

export function getBlockDimensions(pckryInstance, block) {
    const columnWidth = Math.round(pckryInstance.columnWidth),
          rowHeight = Math.round(pckryInstance.rowHeight),
          $block = $(block),
          marginWidth = 14,
          marginHeight = 14,
          maxRows = 10;

    const maxCols = pckryInstance.options.maxColumns || 4;

    let newCoords = {};
    // Must use some round/ceil/floor when doing any arithmetic here!!!!
    newCoords.gridCoordX = Math.ceil($block.outerWidth(true) / columnWidth);
    newCoords.gridCoordX = (newCoords.gridCoordX > maxCols) ? maxCols : newCoords.gridCoordX;
    newCoords.width = (columnWidth * newCoords.gridCoordX) - marginWidth;

    newCoords.gridCoordY = Math.ceil($block.outerHeight(true) / rowHeight);
    newCoords.gridCoordY = (newCoords.gridCoordY > maxRows) ? maxRows : newCoords.gridCoordY;
    newCoords.height = (rowHeight * newCoords.gridCoordY) - marginHeight;

    return newCoords;
}

function lockBlockPosition(ajaxData, blockID, orgID) {
    return ConnectionFactory(
        orgID,
        // TODO: stop hardcoding locale when this is refactored into React
        DefaultController.blockLockPosition("en-US", blockID),
        {
            method: "POST",
            data: ajaxData,
        }
    );
}

function unlockBlockPosition(blockID, orgID) {
    return ConnectionFactory(
        orgID,
        // TODO: stop hardcoding locale when this is refactored into React
        DefaultController.blockUnlockPosition("en-US", blockID),
        {
            method: "POST",
        }
    );
}

const updateGridRequest = {};

export function updateGrid(locale, gridID, sortOrder) {
    if (updateGridRequest.hasOwnProperty(gridID) &&
        updateGridRequest[gridID] !== false &&
        updateGridRequest[gridID].readyState !== 4) {

        updateGridRequest[gridID].abort();
        updateGridRequest[gridID] = false;
    }
    updateGridRequest[gridID] = ConnectionFactory(
        gridID,
        DefaultController.updateGrid(locale, gridID),
        {
            method: 'POST',
            data: {
                ajaxData: sortOrder,
            },
        }
    );
    return updateGridRequest[gridID];
}

export function sb_updateGrid(locale, gridStore, blockID) {
    updateGrid(locale, gridStore.id, gridStore.sortedBlockState).done(function (resp) {
        var code = resp.code;
        var msg = resp.msg;

        //alert(msg + "(" + code + ")");  // deal with data returned
        if (code) {
            NotificationManager.success('Grid layout saved.');
        } else {
            NotificationManager.error(msg + " (" + code + ")");
        }
    }).fail(function (xhr, tStatus, e) {
        var msg;

        if (tStatus === "abort") {
            // because we're aborting requests when another one comes, this isn't a real error
            return;
        }

        msg = "We have an error: " + tStatus;
        if (!xhr && e.hasOwnProperty('message')) {
            msg += " " + e.message;
        }

        NotificationManager.error(msg);
    });
}

export function getEditBlockForm(locale, orgID, blockID, blockType) {
    return ConnectionFactory(
        orgID,
        DefaultController.getEditBlock(locale, blockType),
        {
            cache: false,
            data: {
                blockID: blockID,
            },
        }
    );
}

export function getNewBlockForm(locale, blockType, gridID) {
    return ConnectionFactory(
        gridID,
        DefaultController.getEditBlock(locale, blockType),
        {
            cache: false,
            data: {
                gridID: gridID,
            },
        }
    );
}

export function submitEditBlockForm(locale, orgID, blockID, ajaxData) {
    if (blockID === undefined || blockID === null || blockID === "") {
        blockID = "undefined";
    }

    return ConnectionFactory(
        orgID,
        DefaultController.submitEditBlock(locale, blockID),
        {
            method: "POST",
            dataType: "json",
            data: JSON.stringify(ajaxData),
            processData: false,
            contentType: "application/json",
        }
    );
}

export function uploadBlockImage(locale, orgID, ajaxData, blockID) {
    if (blockID === undefined || blockID === null || blockID === "") {
        blockID = "undefined";
    }
    return ConnectionFactory(
        orgID,
        DefaultController.blockUploadImage(locale, blockID),
        {
            method: "POST",
            data: ajaxData,
            processData: false,
            contentType: false,
        }
    );
}

export function setBlockHeaderTitle(locale, orgID, ajaxData, blockID) {
    return ConnectionFactory(
        orgID,
        DefaultController.blockSetHeaderTitle(locale, blockID),
        {
            method: "POST",
            data: ajaxData,
        }
    )
}

export function getPreviewBlock(locale, blockObj) {
    // if (blockObj.blockType === "sharedfiles") {
    //     const itemsAndSources = await getContentItemsAndSources(blockObj.id)
    //     blockObj.contentItems = await itemsAndSources.contentItems;
    //     blockObj.contentSources = await itemsAndSources.contentSources;
    // }

    if (blockObj.loadAsync) {
        const blockID = blockObj.id;
        const task = {
            url: DefaultController.blockFetch(locale, blockID),
            data: {
                'sizeX': blockObj.sizeX,
                'sizeY': blockObj.sizeY,
                'useAbsoluteUrls': true,
                'usingReact': true,
            },
            dataType: 'json',
        };

        ajaxGetQueue.push(task, 10, (err, data) => {
            if (isJson(data?.html)) {
                const newSettings = JSON.parse(data.html);
                return {
                    ...blockObj,
                    ...newSettings,
                }
            } else return blockObj;
        });
    } else if (isJson(blockObj.htmlOutput)) {
        const newSettings = JSON.parse(blockObj.htmlOutput);
        return {
            ...blockObj,
            ...newSettings,
        }
    } else {
        return blockObj;
    }


}

export async function getContentSources(blockID, userId) {
    const client = await WatsonApi(blockID, userId);
    const result = await client.organizations.organizations_content_sources_list({
        organization_pk: blockID,
        expand: ["items"],
    }, {
        clientAuthorizations: {
            api_key: buildSwaggerAuthorization(blockID, userId, false, null),
        },
    });
    return JSON.parse(result.data).data;
}
